<template>
  <div>
    <Header Act="4"></Header>
    <div class="video-page" @contextmenu.prevent>
      <div class="video-container">
        <div class="back-btn" @click="$router.back()">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        
        <div class="video-header">
          <div class="header-row">
            <div class="header-item">
              <span class="label">项目主题：</span>
              <span class="value">{{ projectTheme }}</span>
            </div>
            <div class="header-item">
              <span class="label">作品名称：</span>
              <span class="value">{{ videoTitle }}</span>
            </div>
          </div>
          <!-- 添加阅读量显示 -->
          <div class="view-count">
            <i class="el-icon-view"></i>
            <span>{{ viewCount }}次观看</span>
          </div>
        </div>

        <div class="video-player-container">
          <div v-if="videoType === '1'">
            <div v-if="isPdf" ref="pdfContainer" class="pdf-viewer" @contextmenu.prevent></div>
            <iframe
              v-else-if="documentPreviewUrl"
              :src="documentPreviewUrl"
              width="100%"
              height="800px"
              frameborder="0"
              style="background:#fff;border:none;"
              class="document-previewer"
              @contextmenu.prevent
            ></iframe>
            <div v-else style="padding:40px;text-align:center;color:#888;">未找到可预览的文档</div>
          </div>
          <div v-else-if="videoType === '2'">
            <div style="width:100%;display:flex;justify-content:center;align-items:center;background:#000;min-height:400px;">
              <img :src="videoUrl" alt="图片作品" style="max-width:100%;max-height:800px;object-fit:contain;" @contextmenu.prevent />
            </div>
          </div>
          <div v-else>
            <video 
              ref="videoPlayer"
              :src="videoUrl" 
              controls 
              controlsList="nodownload"
              class="video-player"
              playsinline
              webkit-playsinline
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-video-orientation="portraint"
              x-webkit-airplay="allow"
              @play="handlePlay"
              @pause="handlePause"
              @ended="handleEnded"
              @error="handleError"
              @contextmenu.prevent
            ></video>
          </div>
        </div>

        <div class="author-info">
          <div class="header-row">
            <div class="header-item">
              <span class="label">作者：</span>
              <span class="value">{{ videoAuthor }}</span>
            </div>
            <div class="header-item">
              <span class="label">单位：</span>
              <span class="value">{{ videoOrganization }}</span>
            </div>
          </div>
        </div>

        <div class="share-container">
          <div class="share-title">分享视频：</div>
          <div class="share-buttons">
            <!-- <el-button type="primary" size="small" @click="copyVideoLink">
              <i class="el-icon-link"></i> 复制链接
            </el-button> -->
            <el-button type="success" size="small" @click="shareToWeChat">
              <i class="el-icon-share"></i> 分享到微信
            </el-button>
            <!-- <el-button type="warning" size="small" @click="testWxShare" v-if="isWeixinBrowser()">
              <i class="el-icon-refresh"></i> 测试分享
            </el-button>
            <el-button type="info" size="small" @click="toggleDebugInfo" v-if="isWeixinBrowser()">
              <i class="el-icon-view"></i> {{ showDebugInfo ? '隐藏调试' : '显示调试' }}
            </el-button> -->
            <!-- <el-button type="warning" size="small" @click="refreshShareConfig" v-if="isWeixinBrowser()">
              <i class="el-icon-refresh"></i> 刷新分享配置
            </el-button> -->
          </div>
          <!-- 添加分享卡片弹窗 -->
          <el-dialog
            title="分享到微信"
            :visible.sync="qrCodeVisible"
            width="360px"
            center
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
          >
            <div class="share-card">
              <div class="share-card-header">
                <img class="share-logo" src="https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/logo.jpg" />
                <div class="share-title-wrapper">
                  <div class="share-card-title">{{ videoTitle }}</div>
                  <div class="share-card-subtitle">来自{{ videoAuthor }}的精彩视频</div>
                </div>
              </div>
              <div class="share-card-body">
                <div class="qrcode-container">
                  <div id="qrcode"></div>
                  <p class="qrcode-tip">微信扫一扫，分享给好友</p>
                </div>
              </div>
              <div class="share-card-footer">
                <el-button type="success" @click="tryDirectShare">
                  <i class="el-icon-mobile-phone"></i> 打开微信粘贴发送
                </el-button>
                <el-button @click="closeQrCode">关闭</el-button>
              </div>
            </div>
          </el-dialog>
          
          <!-- 添加分享状态显示 -->
          <!-- <div class="share-status" v-if="isWeixinBrowser() && showDebugInfo">
            <p>分享初始化状态: {{ shareInitialized ? '已初始化' : '未初始化' }}</p>
            <p>重试次数: {{ initRetryCount }}</p>
            <p>页面加载状态: {{ document.readyState }}</p>
            <p>当前分享标题: {{ videoTitle }}</p>
            <p>当前分享作者: {{ videoAuthor }}</p>
            <p>当前分享单位: {{ videoOrganization }}</p>
            <p>分享链接: {{ shareUrl }}</p>
            <p>分享图片: https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/logo.jpg</p>
          </div> -->
        </div>
        
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../header/head.vue';
import Footer from '../header/footer.vue';
import { Message } from 'element-ui';
import { 
  initWxShare, 
  forceInitWxShare, 
  isWeixinBrowser, 
} from '@/utils/wxShare';
import QRCode from 'qrcodejs2';
import { getVideoById } from '@/data/videos.js'; // 导入通过ID获取视频的函数
import axios from 'axios';

export default {
  name: 'SampleVideo',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      videoId: this.$route.query.videoId || this.$route.query.goodvideoId || 'default', // 设置默认值
      videoTitle: '科普视频样片',
      videoUrl: '',
      videoAuthor: 'BAHIM科普部',
      videoOrganization: '北京协和医院',
      projectTheme: '科普视频制作',
      viewCount: 0,
      qrCodeVisible: false,
      isWxShareInitializing: false,
      shareInitialized: false,
      initRetryCount: 0,
      initRetryTimer: null,
      shareTimer: null,
      showDebugInfo: false,
      pageFullyLoaded: false,
      videoType: '', // 新增：作品类型
      pdfRenderToken: 0,
      pdfRendering: false,
    }
  },
  computed: {
    isPdf() {
      return !!this.videoUrl && this.videoUrl.toLowerCase().endsWith('.pdf');
    },
    officeUrl() {
      if (!this.videoUrl) return '';
      const url = this.videoUrl.toLowerCase();
      const isOffice = url.endsWith('.docx') || url.endsWith('.doc') || url.endsWith('.ppt') || url.endsWith('.pptx') || url.endsWith('.xls') || url.endsWith('.xlsx');
      if (isOffice) {
        return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.videoUrl)}&wdStartOn=1&wdEmbedCode=0&wdHideGridlines=1&wdHideHeaders=1&wdDownloadButton=0&wdInConfigurator=0&wdHideWorksheetTabs=1&wdHideMenus=1&wdHideFormulaBar=1&wdHideStatusBar=1&wdHideRibbon=1`;
      }
      return '';
    },
    googleUrl() {
      if (!this.videoUrl) return '';
      const url = this.videoUrl.toLowerCase();
      const isOffice = url.endsWith('.docx') || url.endsWith('.doc') || url.endsWith('.ppt') || url.endsWith('.pptx') || url.endsWith('.xls') || url.endsWith('.xlsx');
      if (isOffice || url.endsWith('.pdf')) {
        return `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(this.videoUrl)}`;
      }
      return '';
    },
    documentPreviewUrl() {
      // 优先使用 Office Web Viewer，其次使用 Google Docs Viewer
      return this.officeUrl || this.googleUrl || '';
    },
    shareUrl() {
      const currentVideoId = this.videoId;
      const defaultSampleVideoId = 'video_00'; // 定义默认的科普视频样片ID
      let effectiveVideoId = currentVideoId;

      if (!effectiveVideoId) {
        console.log(`shareUrl: 当前视频ID ('${currentVideoId}') 为空。将使用默认视频ID ('${defaultSampleVideoId}') 进行分享。`);
        effectiveVideoId = defaultSampleVideoId;
      }
      
      // 确保baseUrl正确指向目标路由
      const baseUrl = window.location.origin + window.location.pathname + '#/sample-video';
      
      // 根据当前路由参数类型选择参数名
      const isExcellentWork = !!this.$route.query.goodvideoId;
      const paramName = isExcellentWork ? 'goodvideoId' : 'videoId';
      
      const params = new URLSearchParams({
        [paramName]: effectiveVideoId
      });
      return `${baseUrl}?${params.toString()}`;
    }
  },
  methods: {
    // 增加阅读量
    async incrementViewCount(videoId) {
      try {
        // 判断视频类型，选择不同的阅读量接口
        const isPeixunVideo = !!this.$route.query.peixunvideoId;
        const isExcellentWork = !!this.$route.query.goodvideoId;
        
        let viewApiUrl;
        if (isPeixunVideo) {
          viewApiUrl = `/system/peixun/incrementView/${videoId}`;
        } else if (isExcellentWork) {
          viewApiUrl = `/system/works/goodview/${videoId}`;
        } else {
          viewApiUrl = `/system/works/view/${videoId}`;
        }
        
        console.log('使用阅读量接口:', viewApiUrl, '培训视频:', isPeixunVideo, '优秀作品:', isExcellentWork);
        
        // 首先尝试通过GET方法获取当前阅读量
        const getResponse = await axios.get(viewApiUrl);
        console.log('获取阅读量响应:', getResponse.data);
        
        if (getResponse.data.code === 200) {
          // 获取成功，更新显示
          this.viewCount = getResponse.data.data || 0;
          console.log('当前阅读量:', this.viewCount);
          
          // 然后通过POST方法增加阅读量
          try {
            const response = await axios.post(viewApiUrl);
            if (response.data.code === 200) {
              console.log('阅读量增加成功');
              // 增加成功后重新获取最新阅读量
              this.updateViewCount(videoId);
            }
          } catch (error) {
            console.error('增加阅读量失败:', error);
          }
        }
      } catch (error) {
        console.error('阅读量操作失败:', error);
        this.viewCount = 0;
      }
    },
    
    // 更新阅读量显示
    async updateViewCount(videoId) {
      try {
        // 判断视频类型，选择不同的阅读量接口
        const isPeixunVideo = !!this.$route.query.peixunvideoId;
        const isExcellentWork = !!this.$route.query.goodvideoId;
        
        let viewApiUrl;
        if (isPeixunVideo) {
          viewApiUrl = `/system/peixun/incrementView/${videoId}`;
        } else if (isExcellentWork) {
          viewApiUrl = `/system/works/goodview/${videoId}`;
        } else {
          viewApiUrl = `/system/works/view/${videoId}`;
        }
        
        const response = await axios.get(viewApiUrl);
        if (response.data.code === 200) {
          this.viewCount = response.data.data || 0;
          console.log('更新后的阅读量:', this.viewCount);
        }
      } catch (error) {
        console.error('获取更新后的阅读量失败:', error);
      }
    },
    // 导出isWeixinBrowser方法供模板使用
    isWeixinBrowser() {
      return isWeixinBrowser();
    },
    
    // 获取分享数据
    getShareData() {
      // 构建完整的分享数据对象
      const shareData = {
        title: this.videoTitle || '科普视频分享',
        desc: `来自${this.videoAuthor || 'BAHIM科普部'}（${this.videoOrganization || '北京协和医院'}）的精彩视频`,
        link: this.shareUrl, // 使用完整URL分享
        imgUrl: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/logo.jpg',
        videoUrl: this.videoUrl
      };
      
      // 添加调试信息
      console.log('📤 生成分享数据:', {
        title: shareData.title,
        desc: shareData.desc,
        link: shareData.link,
        imgUrl: shareData.imgUrl,
        videoUrl: shareData.videoUrl,
        videoTitle: this.videoTitle,
        videoAuthor: this.videoAuthor,
        videoOrganization: this.videoOrganization
      });
      
      return shareData;
    },
    
    // 初始化微信分享
    async initializeWxShare(forceRefresh = false) {
      // 如果不在微信中，直接返回
      if (!isWeixinBrowser()) {
        this.shareInitialized = false; // 重置状态
        return false;
      }
      
      // 确保分享URL已准备好
      if (!this.shareUrl) {
        console.warn('分享URL尚未准备好，延迟初始化微信分享');
        // 可以在这里加一个延时后重试的逻辑，或者依赖后续的调用
        return false; 
      }

      // 如果正在初始化，避免重复调用
      if (this.isWxShareInitializing && !forceRefresh) { // 允许强制刷新绕过此检查
        console.log('微信分享正在初始化中，跳过常规调用');
        return false;
      }
      
      try {
        console.log('开始初始化微信分享, 强制刷新:', forceRefresh, '页面加载状态:', document.readyState, '当前分享链接:', this.getShareData().link);
        this.isWxShareInitializing = true;
        const shareData = this.getShareData();
        
        let success = false;
        // 无论是首次还是强制刷新，都使用 forceInitWxShare 来确保重新配置
        success = await forceInitWxShare(shareData); 
        
        this.isWxShareInitializing = false;
        
        if (success) {
          console.log('微信分享初始化/更新成功');
          this.shareInitialized = true; // 标记已成功初始化
          this.initRetryCount = 0; // 重置重试计数
          this.setupShareTimer();
          return true;
        } else {
          console.log('微信分享初始化/更新返回失败');
          this.shareInitialized = false;
          // ... (重试逻辑保持不变) ...
          if (this.pageFullyLoaded && this.initRetryCount < 5) {
            this.initRetryCount++;
            console.log(`初始化失败，${this.initRetryCount}秒后自动重试 (${this.initRetryCount}/5)`);
            if (this.initRetryTimer) clearTimeout(this.initRetryTimer);
            this.initRetryTimer = setTimeout(() => {
              this.initializeWxShare(true); // 强制重试
            }, this.initRetryCount * 1000);
          }
          return false;
        }
      } catch (error) {
        console.error('微信分享初始化/更新异常:', error);
        this.isWxShareInitializing = false;
        this.shareInitialized = false;
        // ... (重试逻辑保持不变) ...
        if (this.initRetryCount < 5) {
          this.initRetryCount++;
          console.log(`初始化异常，${this.initRetryCount}秒后重试 (${this.initRetryCount}/5)`);
          if (this.initRetryTimer) clearTimeout(this.initRetryTimer);
          this.initRetryTimer = setTimeout(() => {
            this.initializeWxShare(true); // 强制重试
          }, this.initRetryCount * 1000);
        }
        return false;
      }
    },
    
    // 设置分享定时更新
    setupShareTimer() {
      // 清除之前的定时器
      if (this.shareTimer) {
        clearInterval(this.shareTimer);
      }
      
      // 每30秒更新一次分享配置
      this.shareTimer = setInterval(() => {
        if (isWeixinBrowser() && this.shareInitialized) {
          console.log('定时更新分享配置');
          this.updateWxShare();
        }
      }, 30000); // 30秒
    },
    
    // 更新微信分享配置
    async updateWxShare() {
      if (!isWeixinBrowser()) {
        return false;
      }
      
      try {
        const shareData = this.getShareData();
        return await this.initializeWxShare(true);
      } catch (error) {
        console.error('更新微信分享配置失败:', error);
        return false;
      }
    },
    
    // 手动刷新分享配置
    async refreshShareConfig() {
      try {
        // 显示加载提示
        const loading = this.$loading({
          lock: true,
          text: '刷新分享配置...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
        // 强制重新初始化
        const success = await this.initializeWxShare(true);
        
        // 关闭加载提示
        loading.close();
        
        if (success) {
          Message.success('分享配置已刷新');
        } else {
          Message.warning('分享配置刷新失败，请稍后再试');
        }
      } catch (error) {
        console.error('刷新分享配置失败:', error);
        Message.error('刷新失败，请重试');
      }
    },
    
    copyVideoLink() {
      // 使用完整URL
      navigator.clipboard.writeText(this.shareUrl).then(() => {
        Message.success('链接已复制到剪贴板');
      }).catch(() => {
        Message.error('复制失败，请手动复制');
      });
    },
    
    async shareToWeChat() {
      try {
        // 检查是否登录
        const token = localStorage.getItem('token')
        if (!token) {
          Message.warning('请先登录后再分享')
          this.$router.push('/')
          return
        }

        // 判断是否在微信浏览器中
        if (isWeixinBrowser()) {
          // 显示加载提示
          const loading = this.$loading({
            lock: true,
            text: '准备分享...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          
          try {
            // 在微信浏览器中，每次点击分享按钮时强制刷新微信分享配置
            const success = await this.initializeWxShare(true);
            
            // 关闭加载提示
            loading.close();
            
            if (success) {
              Message.success('请点击右上角"..."按钮进行分享');
            } else {
              // 如果分享初始化失败，仍然提示用户分享，但提示可能存在问题
              Message.warning('分享准备中，如分享不正常，请稍后再试');
            }
          } catch (e) {
            loading.close();
            Message.error('微信分享初始化失败，请稍后重试');
          }
        } else {
          // 不在微信浏览器中，显示分享卡片
          this.showQrCode();
        }
      } catch (error) {
        console.error('分享失败:', error);
        Message.error('分享初始化失败');
        
        // 如果不在微信浏览器中，显示二维码作为备选方案
        if (!isWeixinBrowser()) {
          this.showQrCode();
        }
      }
    },
    
    showQrCode() {
      this.qrCodeVisible = true;
      this.$nextTick(() => {
        const qrcodeElement = document.getElementById('qrcode');
        if (qrcodeElement) {
          qrcodeElement.innerHTML = ''; // 清空之前的二维码

          const qrCodeText = this.shareUrl; // 直接使用计算好的 shareUrl
          console.log("URL for QR Code (using shareUrl): ", qrCodeText);

          new QRCode('qrcode', {
            text: qrCodeText,
            width: 160,
            height: 160,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.L // L级容错率，对于短链接足够
          });
        } else {
          console.error("QR Code DOMELEMENT 'qrcode' not found.");
        }
      });
    },
    
    closeQrCode() {
      this.qrCodeVisible = false;
    },
    
    tryDirectShare() {
      // 构建更丰富的分享内容
      const title = this.videoTitle;
      const desc = `来自${this.videoAuthor}（${this.videoOrganization}）的精彩视频`;
      const link = this.shareUrl; // 使用完整URL
      
      // 创建一个包含缩略图的分享内容
      this.copyRichText(title, desc, link).then(() => {
        // 尝试打开微信
        window.location.href = 'weixin://';
        
        // 显示提示
        Message.success({
          message: '内容已复制到剪贴板，请在微信中粘贴发送',
          duration: 5000  // 显示5秒
        });

        this.closeQrCode();
      }).catch((error) => {
        console.error('复制失败:', error);
        // 退而求其次，复制普通文本
        const shareText = `${title}\n${desc}\n${link}`;
        navigator.clipboard.writeText(shareText).then(() => {
          window.location.href = 'weixin://';
          Message.success({
            message: '内容已复制到剪贴板，请在微信中粘贴发送',
            duration: 5000
          });
          this.closeQrCode();
        }).catch(() => {
          Message.warning('无法复制内容，请手动复制链接后在微信中分享');
        });
      });
    },
    
    // 复制富文本到剪贴板
    copyRichText(title, desc, link) {
      return new Promise((resolve, reject) => {
        try {
          // 创建一个临时容器
          const container = document.createElement('div');
          
          // 使用固定图片
          const imgSrc = 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/logo.jpg';
          
          // 设置富文本内容
          container.innerHTML = `
            <div style="display:flex;align-items:center;background:#f9f9f9;border-radius:4px;padding:10px;margin-bottom:5px;">
              <img src="${imgSrc}" style="width:60px;height:40px;object-fit:cover;border-radius:4px;margin-right:10px;">
              <div>
                <div style="font-weight:bold;font-size:16px;">${title}</div>
                <div style="color:#666;font-size:14px;">${desc}</div>
              </div>
            </div>
            <a href="${link}">${link}</a>
          `;
          
          // 添加到文档中（不可见）
          container.style.position = 'fixed';
          container.style.pointerEvents = 'none';
          container.style.opacity = '0';
          document.body.appendChild(container);
          
          // 选择内容
          const range = document.createRange();
          range.selectNode(container);
          
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          
          // 复制内容
          const successful = document.execCommand('copy');
          
          // 清理
          selection.removeAllRanges();
          document.body.removeChild(container);
          
          if (successful) {
            resolve();
          } else {
            reject(new Error('复制命令失败'));
          }
        } catch (err) {
          reject(err);
        }
      });
    },
    
    // 页面加载完成的处理
    async handlePageLoaded() {
      console.log('页面完全加载完成 (window.load)，尝试初始化微信分享');
      this.pageFullyLoaded = true;
      if (isWeixinBrowser()) {
        await this.initializeWxShare(true); // 强制刷新
      }
    },
    
    // 处理页面可见性变化
    handleVisibilityChange() {
      if (document.visibilityState === 'visible' && isWeixinBrowser()) {
        console.log('页面变为可见，尝试刷新微信分享配置');
        this.initializeWxShare(true); // 强制刷新
      }
    },
    
    // 检查URL参数并尝试更新分享
    async checkUrlParamsAndSetupShare() {
      console.log('执行 checkUrlParamsAndSetupShare');
      const currentVideoId = this.$route.query.videoId || this.$route.query.goodvideoId;
      // const themeFromRoute = this.$route.query.projectTheme; // 不再从路由读取主题

      // if (themeFromRoute) { // 不再从路由读取主题
      //   this.projectTheme = themeFromRoute;
      // } else {
      //   // this.projectTheme = '科普视频制作'; 
      // }
      
      if (this.showDebugInfo || (this.$route.query.debug === 'true' || this.$route.query.debug === '1')) {
        this.showDebugInfo = true;
        console.log('调试模式已启用');
      }

      if (currentVideoId && currentVideoId !== this.videoId) {
        console.log(`路由参数 videoId 发生变化 (或首次加载): ${currentVideoId}`);
        this.videoId = currentVideoId;
        await this.loadVideoData(currentVideoId);
        // videoId 变化意味着分享内容会变，强制初始化分享
        if (isWeixinBrowser()) {
          console.log('videoId变化，强制初始化微信分享');
          await this.initializeWxShare(true);
        }
      } else if (!currentVideoId && this.videoId) {
        // 从有videoId的链接跳转到没有videoId的链接（不太可能，但做个保护）
        console.log('路由中无videoId，但组件内有，可能需要重置或处理');
      } else if (currentVideoId && currentVideoId === this.videoId) {
        // videoId 未变，但可能是组件激活或普通刷新，仍尝试更新分享
        if (isWeixinBrowser() && !this.shareInitialized) { // 只有在未初始化成功时才强制执行
          console.log('videoId未变但分享未初始化，尝试初始化微信分享');
          await this.initializeWxShare(true);
        }
      } else {
        // 首次加载且无videoId（例如直接访问 /sample-video 而没有参数）
        // 这种情况下，应显示默认视频或错误提示
        if (!this.videoId) { // 确保只在真的没有ID时加载默认或错误状态
            await this.loadVideoData(null); // 加载默认/错误状态
        }
        if (isWeixinBrowser()) {
            console.log('无videoId或videoId未变，但仍尝试常规初始化/更新微信分享');
            await this.initializeWxShare(true); // 确保至少有一次初始化
        }
      }
    },
    
    handlePlay() {
      // console.log('视频开始播放');
      // 确保视频继续播放
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.play().catch(error => {
          // console.error('播放失败:', error);
          // 如果播放失败，尝试重新加载视频
          this.$refs.videoPlayer.load();
        });
      }
    },
    
    handlePause() {
      console.log('视频暂停');
      // 如果不是用户主动暂停，则尝试继续播放
      if (this.$refs.videoPlayer && !this.$refs.videoPlayer.paused) {
        this.$refs.videoPlayer.play().catch(error => {
          console.error('恢复播放失败:', error);
        });
      }
    },
    
    handleEnded() {
      console.log('视频播放结束');
    },
    
    handleError(error) {
      console.error('视频播放错误:', error);
      // 发生错误时尝试重新加载视频
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.load();
      }
    },
    
    // 初始化视频播放器
    initVideoPlayer() {
      if (this.$refs.videoPlayer) {
        // 重置视频状态
        this.$refs.videoPlayer.load();
        
        // 添加事件监听
        this.$refs.videoPlayer.addEventListener('play', this.handlePlay);
        this.$refs.videoPlayer.addEventListener('pause', this.handlePause);
        this.$refs.videoPlayer.addEventListener('ended', this.handleEnded);
        this.$refs.videoPlayer.addEventListener('error', this.handleError);
        
        // 尝试自动播放
        this.$refs.videoPlayer.play().catch(error => {
          console.log('自动播放失败，等待用户交互:', error);
        });
      }
    },
    
    // 增加一个调试方法
    async testAPIs(videoId) {
      console.log('开始测试APIs，videoId:', videoId);
      try {
        // 测试直接通过ID参数查询
        console.log('测试 /system/works/jianji/list 直接ID参数查询');
        try {
          const idResponse = await axios.get(`/system/works/jianji/list`, {
            params: {
              id: videoId
            }
          });
          console.log('ID参数查询结果:', idResponse.data);
        } catch (err) {
          console.error('ID参数查询调用失败:', err);
        }
        
        // 测试带分页的系统列表接口
        console.log('测试 /system/works/jianji/list 带分页参数');
        try {
          const pageResponse = await axios.get(`/system/works/jianji/list`, {
            params: {
              pageSize: 100,
              pageNum: 1
            }
          });
          console.log('分页查询返回结果总数:', pageResponse.data.rows ? pageResponse.data.rows.length : 0);
          if (pageResponse.data.rows) {
            const found = pageResponse.data.rows.find(item => item.id == videoId);
            console.log('在分页结果中找到匹配ID:', found ? '是' : '否');
          }
        } catch (err) {
          console.error('分页查询调用失败:', err);
        }
        
        // 测试工作信息接口
        console.log('测试 /api/v1/works/workinfo 接口');
        try {
          const workResponse = await axios.get(`/api/v1/works/workinfo/${videoId}`);
          console.log('工作信息接口返回结果:', workResponse.data);
        } catch (err) {
          console.error('工作信息接口调用失败:', err);
        }
        
        // 测试阅读量接口
        console.log('测试阅读量接口');
        try {
          // 判断视频类型，选择不同的阅读量接口
          const isPeixunVideo = !!this.$route.query.peixunvideoId;
          const isExcellentWork = !!this.$route.query.goodvideoId;
          
          let viewApiUrl;
          if (isPeixunVideo) {
            viewApiUrl = `/system/peixun/incrementView/${videoId}`;
          } else if (isExcellentWork) {
            viewApiUrl = `/system/works/goodview/${videoId}`;
          } else {
            viewApiUrl = `/system/works/view/${videoId}`;
          }
          
          console.log('使用阅读量接口:', viewApiUrl, '培训视频:', isPeixunVideo, '优秀作品:', isExcellentWork);
          
          const viewResponse = await axios.get(viewApiUrl);
          console.log('阅读量接口返回结果:', viewResponse.data);
        } catch (err) {
          console.error('阅读量接口调用失败:', err);
        }
      } catch (error) {
        console.error('API测试失败:', error);
      }
    },
    
    // 修改 loadVideoData 方法
    async loadVideoData(videoId) {
      console.log('开始加载视频数据，videoId:', videoId);
      
      // 检查是否是培训数据（通过peixunvideoId参数）
      const q = this.$route.query || {};
        if (q.peixunvideoId) {
          console.log('检测到peixunvideoId参数，调用培训数据接口');
          try {
            const response = await this.$get(`/system/peixun/${videoId}`);
            console.log('培训数据接口响应:', response.data);
            
            if (response.data.code === 200) {
              // 尝试不同的数据结构
              const peixunData = response.data.data || response.data.rows || response.data;
              console.log('培训数据:', peixunData);
              
              if (peixunData) {
                this.videoTitle = peixunData.worksName || '未知标题';
                this.videoUrl = peixunData.vedioFile || '';
                this.videoAuthor = peixunData.name || '未知作者';
                this.videoOrganization = peixunData.danwei || '未知单位';
                this.projectTheme = peixunData.project || '未知主题';
                this.videoType = peixunData.type || '';
                this.viewCount = peixunData.viewCount || 0;
                console.log('培训数据加载成功:', peixunData);
                
                // 直接渲染，不调用其他接口
                this.$nextTick(() => {
                  this.initVideoPlayer();
                  if (this.isPdf) {
                    this.schedulePdfRender();
                  }
                });
                return;
              } else {
                console.error('培训数据为空');
              }
            } else {
              console.error('培训数据接口返回错误:', response.data.msg);
            }
          } catch (error) {
            console.error('调用培训数据接口失败:', error);
          }
        }
      
      // 优先使用路由传入的数据（适用于文档/图片/已知资源）
      if (q.videoUrl && q.worksType) {
        this.videoTitle = q.worksName || this.videoTitle;
        this.viewCount = q.viewCount || this.viewCount;
        this.videoUrl = q.videoUrl;
        this.videoAuthor = q.userName || this.videoAuthor;
        this.videoOrganization = q.userUnit || this.videoOrganization;
        this.projectTheme = q.projectTheme || this.projectTheme;
        this.videoType = q.worksType || this.videoType;
        console.log('使用路由数据渲染内容:', {
          videoTitle: this.videoTitle,
          videoUrl: this.videoUrl,
          videoAuthor: this.videoAuthor,
          videoOrganization: this.videoOrganization,
          projectTheme: this.projectTheme,
          videoType: this.videoType
        });
        // 直接渲染，不调用接口
        this.$nextTick(() => {
          this.initVideoPlayer();
          if (this.isPdf) {
            this.schedulePdfRender();
          }
        });
        return;
      }
      
      // 检查本地视频数据（videos.js）
      if (videoId) {
        try {
          const localVideo = getVideoById(videoId);
          if (localVideo) {
            console.log('从本地数据中找到视频:', localVideo);
            this.videoTitle = localVideo.title || '科普视频样片';
            this.videoUrl = localVideo.url || '';
            this.videoAuthor = localVideo.author || '科普视频样片';
            this.videoOrganization = localVideo.organization || '科普视频样片';
            this.projectTheme = localVideo.projectTheme || '无';
            this.videoType = '3'; // 默认为视频类型
            this.viewCount = 0;
            // 直接渲染，不调用接口
            this.$nextTick(() => {
              this.initVideoPlayer();
              if (this.isPdf) {
                this.schedulePdfRender();
              }
            });
            return;
          }
        } catch (error) {
          console.error('检查本地视频数据失败:', error);
        }
      }
      
      if (!videoId) {
        console.error('尝试加载视频数据但 videoId 为空');
        this.videoTitle = '视频未找到';
        this.videoUrl = '';
        this.videoAuthor = '';
        this.videoOrganization = '';
        this.projectTheme = '视频主题加载失败';
        return;
      }

      // 判断是否是优秀作品（通过goodvideoId参数）
      const isExcellentWork = !!this.$route.query.goodvideoId;
      const apiUrl = isExcellentWork ? '/system/works/goodjianji/list' : '/system/works/jianji/list';
      console.log('使用接口:', apiUrl, '是否为优秀作品:', isExcellentWork);

      // 在开发环境下测试APIs
      if (process.env.NODE_ENV === 'development') {
        await this.testAPIs(videoId);
      }

      try {
        let found = false;
        
        // 首先尝试直接通过ID参数查询
        try {
          const idResponse = await axios.get(apiUrl, {
            params: {
              id: videoId
            }
          });
          
          if (idResponse.data.code === 200 && idResponse.data.rows && idResponse.data.rows.length > 0) {
            // 应该只返回一条匹配的记录
            const videoData = idResponse.data.rows[0];
            found = true;
            this.videoTitle = videoData.worksName || '未知标题';
            this.videoUrl = videoData.vedioFile || '';
            this.videoAuthor = videoData.userName || '未知作者';
            this.videoOrganization = videoData.userUnit || '未知单位';
            this.projectTheme = videoData.projectCase || '未知主题';
            this.videoType = videoData.worksType || '';
            console.log('通过ID参数查询成功:', videoData);
          } else {
            console.log('通过ID参数查询未找到匹配记录');
          }
        } catch (error) {
          console.error('通过ID参数查询失败:', error);
        }
        
        // 如果通过ID参数查询失败，尝试加载更多数据查找
        if (!found) {
          try {
            // 请求大量数据，增加查找成功的可能性
            const systemResponse = await axios.get(apiUrl, {
              params: {
                pageSize: 100, // 请求更多条目
                pageNum: 1
              }
            });
            
            if (systemResponse.data.code === 200 && systemResponse.data.rows) {
              // 在所有作品中查找匹配的ID
              const videoData = systemResponse.data.rows.find(item => item.id == videoId);
              if (videoData) {
                found = true;
                this.videoTitle = videoData.worksName || '未知标题';
                this.videoUrl = videoData.vedioFile || '';
                this.videoAuthor = videoData.userName || '未知作者';
                this.videoOrganization = videoData.userUnit || '未知单位';
                this.projectTheme = videoData.projectCase || '未知主题';
                this.videoType = videoData.worksType || '';
                console.log('通过列表查找成功:', videoData);
              } else {
                console.log('在列表中未找到匹配ID:', videoId);
              }
            }
          } catch (error) {
            console.error('列表查询失败:', error);
          }
        }
        
        // 如果前两个接口都失败，直接失败，不再尝试其他接口
        if (!found) {
          console.error(`未找到 Video ID: ${videoId} 的视频数据，前两个接口都失败`);
          this.videoTitle = '视频加载失败';
          this.videoUrl = '';
          this.videoAuthor = '';
          this.videoOrganization = '';
          this.projectTheme = '视频主题加载失败';
          this.videoType = '';
          return;
        }

        // 初始化视频播放器
        this.$nextTick(() => {
          this.initVideoPlayer();
          if (this.isPdf) {
            this.schedulePdfRender();
          }
        });
      } catch (error) {
        console.error('加载视频数据失败:', error);
        this.videoTitle = '视频加载失败';
        this.videoUrl = '';
        this.videoAuthor = '';
        this.videoOrganization = '';
        this.projectTheme = '视频主题加载失败';
        this.videoType = '';
      }
    },
    // 调度 PDF 渲染，避免并发重复渲染
    async schedulePdfRender() {
      if (!this.isPdf) return;
      const currentToken = ++this.pdfRenderToken;
      await this.$nextTick();
      // 再次确认容器存在
      if (!this.$refs.pdfContainer) return;
      await this.renderPdfWithPdfjs(currentToken);
    },
    // 使用 PDF.js 在页面内渲染 PDF（无工具栏）
    async renderPdfWithPdfjs(token) {
      try {
        if (!this.$refs.pdfContainer || !this.videoUrl) return;
        this.pdfRendering = true;
        this.clearPdf();
        // 动态加载 pdf.js
        if (!window.pdfjsLib) {
          await this.loadPdfJsScripts();
        }
        if (!window.pdfjsLib) return;
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
        const loadingTask = window.pdfjsLib.getDocument({ url: this.videoUrl, withCredentials: false });
        const pdf = await loadingTask.promise;
        const container = this.$refs.pdfContainer;
        const containerWidth = container.clientWidth || container.offsetWidth || 800;
        const dpr = window.devicePixelRatio || 1;
        // 渲染所有页面
        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          // 若有新的渲染任务开始，则中断当前渲染
          if (token !== this.pdfRenderToken) {
            break;
          }
          const page = await pdf.getPage(pageNum);
          const baseViewport = page.getViewport({ scale: 1 });
          const scale = containerWidth / baseViewport.width;
          const viewport = page.getViewport({ scale });
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.width = Math.floor(viewport.width * dpr);
          canvas.height = Math.floor(viewport.height * dpr);
          canvas.style.display = 'block';
          canvas.style.margin = '0 auto 12px';
          canvas.style.width = '100%';
          canvas.style.height = 'auto';
          context.setTransform(dpr, 0, 0, dpr, 0, 0);
          // 渲染前再次确认没有被新的任务取代
          if (token !== this.pdfRenderToken) {
            break;
          }
          container.appendChild(canvas);
          await page.render({ canvasContext: context, viewport }).promise;
        }
      } catch (e) {
        console.error('PDF 渲染失败:', e);
        // 回退到原始 iframe 方案
      } finally {
        // 仅在当前 token 仍有效时重置状态
        if (token === this.pdfRenderToken) {
          this.pdfRendering = false;
        }
      }
    },
    handlePdfResize() {
      if (!this.isPdf) return;
      if (this._pdfResizeTimer) clearTimeout(this._pdfResizeTimer);
      this._pdfResizeTimer = setTimeout(() => {
        this.schedulePdfRender();
      }, 200);
    },
    clearPdf() {
      const container = this.$refs.pdfContainer;
      if (container) {
        while (container.firstChild) {
          container.removeChild(container.firstChild);
        }
      }
    },
    loadPdfJsScripts() {
      return new Promise((resolve, reject) => {
        if (window.pdfjsLib) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('pdf.js 加载失败'));
        document.head.appendChild(script);
      });
    },
    
    fanhui() {
      this.$router.back()
    },

    async testWxShare() {
      console.log('手动触发微信分享测试...');
      try {
        const loading = this.$loading({
          lock: true,
          text: '测试中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        const success = await this.initializeWxShare(true);
        loading.close();

        if (success) {
          Message.success('微信分享测试成功！');
        } else {
          Message.warning('微信分享测试失败，请检查控制台日志。');
        }
      } catch (error) {
        console.error('微信分享测试失败:', error);
        Message.error('微信分享测试失败，请检查控制台日志。');
      }
    },

    toggleDebugInfo() {
      this.showDebugInfo = !this.showDebugInfo;
      console.log('调试模式已切换为:', this.showDebugInfo ? '显示' : '隐藏');
    }
  },
  async created() {
    console.log('组件创建 (created) - SampleVideo');
    // 获取视频ID，优先检查peixunvideoId
    const peixunvideoId = this.$route.query.peixunvideoId;
    const videoId = peixunvideoId || this.$route.query.videoId || this.$route.query.goodvideoId;
    
    if (videoId) {
      this.videoId = videoId;
      // 先加载视频数据
      await this.loadVideoData(videoId);
      // 增加阅读量
      await this.incrementViewCount(videoId);
    } else {
      console.warn('SampleVideo created: 未在路由中找到videoId，将使用默认视频信息。');
      await this.loadVideoData('default');
    }
  },
  async mounted() {
    console.log('组件挂载完成 (mounted) - SampleVideo');
    
    await this.checkUrlParamsAndSetupShare();
    
    window.addEventListener('load', this.handlePageLoaded);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('resize', this.handlePdfResize);
    
    // 初始化视频播放器
    this.$nextTick(() => {
      this.initVideoPlayer();
      if (this.isPdf) {
        this.schedulePdfRender();
      }
    });
    
    const retryIntervals = [1500, 3000, 6000]; 
    retryIntervals.forEach((delay, index) => {
      setTimeout(async () => {
        if (!this.shareInitialized && isWeixinBrowser()) {
          console.log(`Mounted 定时任务 ${index+1}：尝试初始化微信分享`);
          await this.initializeWxShare(true);
        }
      }, delay);
    });
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('load', this.handlePageLoaded);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    
    // 移除视频事件监听
    if (this.$refs.videoPlayer) {
      this.$refs.videoPlayer.removeEventListener('play', this.handlePlay);
      this.$refs.videoPlayer.removeEventListener('pause', this.handlePause);
      this.$refs.videoPlayer.removeEventListener('ended', this.handleEnded);
      this.$refs.videoPlayer.removeEventListener('error', this.handleError);
    }
    
    // 清除所有定时器
    if (this.initRetryTimer) {
      clearTimeout(this.initRetryTimer);
    }
    
    if (this.shareTimer) {
      clearInterval(this.shareTimer);
    }
    // 清理 PDF 画布
    this.clearPdf();
    window.removeEventListener('resize', this.handlePdfResize);
    // 使进行中的渲染失效
    this.pdfRenderToken++;
    this.pdfRendering = false;
  },
  async activated() {
    console.log('组件激活 (activated) - SampleVideo');
    const videoId = this.$route.query.videoId || this.$route.query.goodvideoId;
    
    if (videoId && videoId !== this.videoId) {
      console.log('组件激活时videoId变化，从', this.videoId, '变为', videoId);
      this.videoId = videoId;
      await this.loadVideoData(videoId);
    } else if (videoId && videoId === this.videoId) {
      // 如果ID没变但组件被重新激活，只更新阅读量
      await this.updateViewCount(videoId);
    }
    
    await this.checkUrlParamsAndSetupShare();
  },
  watch: {
    '$route': {
      async handler(to, from) {
        console.log('路由发生变化 ($route watch) - SampleVideo');
        // 检查peixunvideoId和videoId参数
        const newPeixunVideoId = to.query.peixunvideoId;
        const newVideoId = to.query.videoId;
        const oldPeixunVideoId = from && from.query ? from.query.peixunvideoId : null;
        const oldVideoId = from && from.query ? from.query.videoId : null;
        
        // 优先使用peixunvideoId
        const currentVideoId = newPeixunVideoId || newVideoId;
        const previousVideoId = oldPeixunVideoId || oldVideoId;
        
        // 只有当videoId实际改变时才重新加载数据
        if (currentVideoId !== previousVideoId) {
          console.log('videoId发生变化，从', previousVideoId, '变为', currentVideoId);
          if (currentVideoId) {
            this.videoId = currentVideoId;
            // 加载视频数据
            await this.loadVideoData(currentVideoId);
          }
        }
        
        await this.checkUrlParamsAndSetupShare();
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.video-page {
  background: #fff;
  min-height: 100vh;
  padding: 20px;
}

.video-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background: #fff;
  position: relative;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s;
  margin-bottom: 20px;
}

.back-btn:hover {
  color: #409EFF;
  background: #f5f7fa;
}

.back-btn i {
  margin-right: 4px;
  font-size: 16px;
}

.video-header {
  margin-bottom: 20px;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.header-item {
  flex: 1;
  font-size: 16px;
  color: #333;
}

.header-item .label {
  color: #666;
  margin-right: 8px;
}

.header-item .value {
  color: #333;
  font-weight: 500;
}

.video-player-container {
  width: 100%;
  margin: 20px 0;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}

.video-player {
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: contain;
}

.share-container {
  margin: 20px 0;
  padding: 15px;
  background: #f8fafc;
  border-radius: 8px;
}

.share-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
}

.share-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.share-buttons .el-button {
  display: flex;
  align-items: center;
  gap: 5px;
}

.share-buttons .el-button i {
  font-size: 16px;
}

.share-card {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.share-card-header {
  display: flex;
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.share-logo {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  margin-right: 12px;
  object-fit: contain;
}

.share-title-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.share-card-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
}

.share-card-subtitle {
  font-size: 13px;
  color: #666;
}

.share-card-body {
  padding: 20px;
  display: flex;
  justify-content: center;
}

.qrcode-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode-tip {
  margin-top: 15px;
  color: #666;
  font-size: 14px;
}

#qrcode {
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}

.share-card-footer {
  display: flex;
  justify-content: center;
  gap: 15px;
  padding: 15px;
  border-top: 1px solid #f0f0f0;
}

.author-info {
  margin-top: 20px;
  padding: 15px 20px;
  background: #f8fafc;
  border-radius: 8px;
}

.share-status {
  margin-top: 15px;
  padding: 8px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  background: #f9f9f9;
  font-size: 12px;
  color: #666;
}

.share-status p {
  margin: 4px 0;
}

/* 删除不需要的样式 */
.project-theme,
.work-title,
.info-item {
  display: none;
}

.view-count {
  margin-top: 10px;
  color: #666;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.view-count i {
  font-size: 16px;
}

/* 文档预览器样式 */
.document-previewer {
  border: none !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border-radius: 8px;
  overflow: hidden;
}

.pdf-viewer {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  height: 60vh;
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.pdf-viewer canvas {
  width: 100% !important;
  height: auto !important;
}

@media screen and (max-width: 768px) {
  .pdf-viewer {
    height: 50vh;
    max-height: 50vh;
    padding: 12px;
  }
}
</style> 